export default __webpack_public_path__ + "static/media/vip4.aca84ec2.webp";